<template>
  <div>
    <!-- 图片压缩 -->
    <image-compressor v-if="uploadComplete" :imageObj="uploadImageInfo" @back="handleBack" />
    <image-upload @uploadComplete="handleUploadComplete" v-else />
  </div>
</template>
<script setup>
import ImageUpload from "./image-upload.vue";
import ImageCompressor from "@/components/image-compressor/index.vue";
import { ref } from "vue";
import { eventTracking } from "@/utils/eventTracking.js";
import { useCheckResourceStore } from "@/store";
import { authenticator } from "@/utils";

const { deductResourceFn } = useCheckResourceStore();
const uploadComplete = ref(false);
const uploadImageInfo = ref({});

const handleUploadComplete = async (imageObj) => {
  eventTracking("booltool_page_upload", { tool_name: "compressor", is_batch: false })
  await deductResourceFn('IMAGE_COMPRESSOR', false);
  await authenticator.refresh();
  uploadComplete.value = true;
  uploadImageInfo.value = imageObj;
};

const handleBack = () => {
  uploadImageInfo.value = {};
  uploadComplete.value = false;
};
</script>

<style lang="less">

</style>
